module.exports = __webpack_public_path__ + "static/media/search-icon.52756337.svg";